/* @flow */

import _ from 'lodash';
import { compose, branch, renderComponent } from 'recompose';

import ErrorComponent from '../components/ErrorComponent';

const withErrorHandler = compose(
  branch(props => props.hasError, renderComponent(ErrorComponent), _.identity),
);

export default withErrorHandler;



// WEBPACK FOOTER //
// ./src/hoc/withErrorHandler.js